import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "lista"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h1", null, " Você não esta produtivo ", -1)
const _hoisted_3 = { class: "lista" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FormularioVue = _resolveComponent("FormularioVue")!
  const _component_vue_box = _resolveComponent("vue-box")!
  const _component_TarefaVue = _resolveComponent("TarefaVue")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_FormularioVue, { onAoSalvarTarefa: _ctx.salvarTarefa }, null, 8, ["onAoSalvarTarefa"]),
    (_ctx.tarefas.length === 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_vue_box, null, {
            default: _withCtx(() => [
              _hoisted_2
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tarefas, (tarefa, i) => {
        return (_openBlock(), _createBlock(_component_TarefaVue, {
          key: i,
          tarefa: tarefa,
          id: i
        }, null, 8, ["tarefa", "id"]))
      }), 128))
    ])
  ], 64))
}